export default (that) => [
  {
    field: 'seq',
    width: 60,
    fixed: 'left',
    align: 'center',
    type: 'seq',
  },
  // {
  //   field: 'checkbox',
  //   width: 40,
  //   align: 'center',
  //   fixed: 'left',
  //   type: 'checkbox',
  // },
  {
    field: 'col-opt',
    title: that.$l('table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    field: 'displayImage',
    title: that.$l('table_label_image') || '图片',
    width: 120,
    align: 'center',
    fixed: 'left',
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_displayFabricName') || '面料系列名称',
    field: 'displayFabricName',
    minWidth: 300,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayFabricName' },
  },
  {
    title: that.$l('table_label_fabricSeriesStatus') || '状态',
    field: 'fabricSeriesStatus',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'fabricSeriesStatus' },
  },
  {
    title: that.$l('table_label_displayWid') || '克重',
    field: 'fabricWeight',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'fabricWeight' },
  },
  {
    title: that.$l('table_label_displayFabricContent') || '面料成分',
    field: 'displayFabricContent',
    minWidth: 180,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayFabricContent' },
  },
  {
    title: that.$l('table_label_fabricAgentName') || '业务开发',
    field: 'fabricAgentName',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  // {
  //   title:that.$l('table_label_displayPrice') || '单价',
  //   field: 'displayPrice',
  //   minWidth: 150,
  //   align: 'left',
  //   showHeaderOverflow: true,
  //   slots: { default: 'displayPrice' },
  // },
  {
    title: that.$l('table_label_displayCreate') || '创建人',
    field: 'displayCreate',
    minWidth: 170,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayCreate' },
  },
  {
    title: that.$l('table_label_displayModify') || '修改人',
    field: 'displayModify',
    minWidth: 170,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  },
  {
    title: that.$l('table_label_displaySubmitBy') || '提交审批人',
    field: 'displaySubmitBy',
    minWidth: 170,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displaySubmitBy' },
  },
  {
    title: that.$l('table_label_displayApprovalBy') || '审批人',
    field: 'displayApprovalBy',
    minWidth: 170,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayApprovalBy' },
  },

]
